import AssessmentList from '../pages/assessment/AssessmentList';
import AssessmentForm from '../pages/assessment/AssessmentForm';

export const apiRoutes = {
  login: '/account/login',
  forgotPassword: '/account/forgotPassword',
  resetPassword: '/account/resetPassword',
  users: '/account/users',
  user: '/account/user',
};

export const pageRoutes = {
  /* public routes */
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',

  /* private routes */
  dashboard: '/',
  manageJob: '/jobs',
  jobManagement: '/jobManagement',
  manageCandidate: '/manage-candidate',
  manageUser: '/manage-user',
  manageRevenue: '/manage-revenue',
  manageCMS: '/manage-cms',
  subjects: '/subjects',
  skills: '/skills',
  addQuestions: '/add-questions',
  questions: '/questions',

  candidate: '/candidate',
  employer: '/employer',

  codingChallenge: '/coding-challenge',
  codingProblem: '/coding-problem',
  editCodingProblem: '/edit-coding-problem',

  codingSubmission: '/coding-submission',
  viewTestSubmission: '/test-submission',

  assessments: '/assessments',
  createAssessment: '/assessments/create',
  editAssessment: '/assessments/edit',
};

const routes = [
  {
    path: '/assessments',
    element: <AssessmentList />,
    name: 'Assessment Management',
    icon: 'AssessmentOutlined',
  },
  {
    path: '/assessments/create',
    element: <AssessmentForm />,
    name: 'Create Assessment',
    icon: 'AssessmentOutlined',
  },
  {
    path: '/assessments/edit/:id',
    element: <AssessmentForm />,
    name: 'Edit Assessment',
    icon: 'AssessmentOutlined',
  },
];

export default routes;
